/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import {Module, Node} from "@msdyn365-commerce-modules/utilities";
import React, {ReactNode} from "react";
import {IFooterCategoryViewProps} from "@msdyn365-commerce-modules/footer/";

export const FooterCategoryView: React.FC<IFooterCategoryViewProps> = (
  props: any,
) => {
  if (
    typeof window !== "undefined" &&
    typeof document !== "undefined" &&
    typeof localStorage !== "undefined"
  ) {
    const {categories, FooterList, FooterListItem, friendlyName} = props;
    // const [cookieModal, setCookieModal] = React.useState<any>(false);

    if (!categories || !categories.length) {
      props.context.telemetry.error(
        "Footer content is empty, module wont render",
      );
      return null;
    }

    // function openCookieModal(){
    //   // localStorage.setItem("cookie_modal","true")

    // }

    React.useEffect(() => {
      window.addEventListener("CookiebotOnDecline", () => {
        if (document.querySelector("body")?.style.overflow == "hidden") {
          window.location.reload();
        }
      });

      window.addEventListener("CookiebotOnAccept", () => {
        if (document.querySelector("body")?.style.overflow == "hidden") {
          window.location.reload();
        }
      });
    }, []);
    setTimeout(() => {
      const openCookieBot = () => {
        const cookieBot: any = window.CookieConsent;
        cookieBot.show();
      };

      document
        .querySelector(".cookie-selector")
        ?.addEventListener("click", () => {
          openCookieBot();
        });
    }, 1200);

    return (
      <Module {...FooterList}>
        {categories.map((category: ReactNode, index: number) => {
          if (index == 0 && friendlyName == "Social footer category") {
            return <>{category}</>;
          }
          return (
            <Node {...FooterListItem} key={index}>
              {category}
            </Node>
          );
        })}

        {/* {cookieModal ? (
          <Modal
            isOpen={cookieModal}
            className="ms-cookie-compliance__container"
            color="white"
            fade={false}
          >
              <h2>{props.resources.headingCookie}</h2>
              <p>{props.resources.cookieContent}</p>
              <button className="cancel-btn" onClick={() => setCookieModal(false)}>X</button>
          </Modal>
        ) : null} */}
      </Module>
    );
  } else {
    return <></>;
  }
};

export default FooterCategoryView;
